// Configure FontAwesome to avoid inline styles for Content-Security-Policy
import { config as fontawesomeConfig } from "@fortawesome/fontawesome-svg-core";
import "@fortawesome/fontawesome-svg-core/styles.css";

fontawesomeConfig.autoAddCss = false;
